export const AUTH_TOKEN_KEYS = {
  accessToken: 'livable_access_token',
  refreshToken: 'livable_refresh_token',
  expiresOn: 'livable_expires_in',
  requireMfa: 'livable_require_mfa',
  session: 'livable_session_token',
  demoPropertyMode: 'livable_demo_mode'
};